import { action, CubePresenter, FlipIntent, Logger, Presenter } from 'wdc-cube'

import { MainPresenter } from 'src/main/Main.presenter'
import PFKeys from './pf.keys'
import PFScope, { HeaderScope } from './pf.scopes'
import pfService from './pf.service'

const LOG = Logger.get('PFPresenter')

export class PFPresenter extends CubePresenter<MainPresenter, PFScope> {
    // :: Fields

    private readonly __headerBar: Presenter<HeaderScope, PFPresenter>

    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new PFScope())
        this.__headerBar = new Presenter(this, this.scope.header)
    }

    // :: Methods

    public override release() {
        this.app.releaseToolbar(this.__headerBar)
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new PFKeys(this.app, intent)

        this.app.scope.toolbar = this.__headerBar.scope

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }

        keys.parentSlot(this.scope)

        return keys.allow
    }

    async #initialize() {
        LOG.debug('initialize')
        this.scope.onFind = this.handleFind.bind(this)
    }

    @action()
    private async handleFind() {
        try {
            if (this.scope.cpfSelected.length !== 11) {
                this.alert('error', 'CPF inválido', 'O CPF informado é inválido. Verifique e tente novamente.')
                return
            }
            const person = await pfService.fetchPersonInfo(this.scope.cpfSelected)
            this.scope.persons = [person]
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        }
    }
}

export default PFPresenter
